// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CommonStyles__loadingFrame___T8QeT {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
}

.CommonStyles__loadingTimer___PoPvv {
    align-self: center;
}

.CommonStyles__timerPosition___xXzvz {
    margin-bottom: 0.8rem;
}

.CommonStyles__iconStyle___fhqNb {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 5rem;
    height: 5rem;
    padding: 1.25rem;

    background: var(--color-control-bg-ghost);
    border-radius: 2.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/MasterImport/Common/CommonStyles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,WAAW;IACX,YAAY;IACZ,gBAAgB;;IAEhB,yCAAyC;IACzC,qBAAqB;AACzB","sourcesContent":[".loadingFrame {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n}\n\n.loadingTimer {\n    align-self: center;\n}\n\n.timerPosition {\n    margin-bottom: 0.8rem;\n}\n\n.iconStyle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    width: 5rem;\n    height: 5rem;\n    padding: 1.25rem;\n\n    background: var(--color-control-bg-ghost);\n    border-radius: 2.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingFrame": `CommonStyles__loadingFrame___T8QeT`,
	"loadingTimer": `CommonStyles__loadingTimer___PoPvv`,
	"timerPosition": `CommonStyles__timerPosition___xXzvz`,
	"iconStyle": `CommonStyles__iconStyle___fhqNb`
};
export default ___CSS_LOADER_EXPORT___;
